import React, { useState } from "react";
import axios from "axios";
import { useNavigate, Navigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Lock, Loader2 } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
axios.defaults.withCredentials = true;

const AdminLoginPage = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [authed, setAuthed] = useState(false);
  const nav = useNavigate();

  React.useEffect(() => {
    axios.get(`${API}/admin/me`).then(() => setAuthed(true)).catch(() => {});
  }, []);

  if (authed) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/admin/login`, { username, password });
      toast.success("Signed in");
      nav("/admin", { replace: true });
    } catch (err) {
      const msg = err?.response?.status === 429 ? "Too many attempts. Try again shortly." : "Invalid credentials";
      toast.error(msg);
    } finally { setLoading(false); }
  };

  return (
    <section className="min-h-screen flex items-center justify-center bg-[var(--ct-bg)] px-4">
      <Helmet><meta name="robots" content="noindex, nofollow" /><title>Admin — Crosstown Movers</title></Helmet>
      <form onSubmit={submit} data-testid="admin-login-form" className="w-full max-w-md bg-white rounded-3xl p-8 border border-[var(--ct-border)] shadow-[0_20px_60px_rgba(0,0,0,0.08)]">
        <div className="w-14 h-14 rounded-2xl bg-[var(--ct-primary)] text-[var(--ct-secondary)] flex items-center justify-center mx-auto">
          <Lock className="w-6 h-6" />
        </div>
        <h1 className="mt-5 text-2xl font-bold text-center text-[var(--ct-primary)]" style={{ fontFamily: "Outfit" }}>Crosstown Movers Admin</h1>
        <p className="mt-1 text-sm text-center text-[var(--ct-text-muted)]">Sign in to view leads</p>
        <label className="block mt-6">
          <span className="text-xs font-bold uppercase tracking-[0.15em] text-[var(--ct-primary)]">Username</span>
          <input data-testid="admin-username" value={username} onChange={(e) => setUsername(e.target.value)} required autoComplete="username"
            className="mt-2 w-full bg-white border border-[var(--ct-border)] rounded-lg px-4 py-3 focus:ring-2 focus:ring-[var(--ct-primary)] outline-none" />
        </label>
        <label className="block mt-4">
          <span className="text-xs font-bold uppercase tracking-[0.15em] text-[var(--ct-primary)]">Password</span>
          <input type="password" data-testid="admin-password" value={password} onChange={(e) => setPassword(e.target.value)} required autoComplete="current-password"
            className="mt-2 w-full bg-white border border-[var(--ct-border)] rounded-lg px-4 py-3 focus:ring-2 focus:ring-[var(--ct-primary)] outline-none" />
        </label>
        <button type="submit" disabled={loading} data-testid="admin-login-submit" className="btn-primary mt-6 w-full disabled:opacity-50">
          {loading ? <><Loader2 className="w-4 h-4 animate-spin" /> Signing in…</> : "Sign in"}
        </button>
      </form>
    </section>
  );
};

export default AdminLoginPage;
